import { useEffect, useState, useCallback, useRef } from "react";
import styles from "./index.module.scss";
import {
  postCall,
  putCall,
  // postCallWithoutAuth,
  // putCallWithoutAuthForAWSUrl,
} from "../../services/apiService";
import { useLocation, useNavigate, useSearchParams } from "react-router-dom";
import Loader from "../../common/components/Loader";
import RegistrationHeader from "../../components/registration/RegistrationHeader";
import { Button } from "../../common/components/Button";
import { endPoints } from "../../constants/urlConstants";
// import BirthDatePicker from "../../common/components/DatePicker";
import { getItemInLocalStorage } from "../../services/localStorage";
import useRazorpay from "../../components/RazorPayments";
import EventDetailsSection from "../../components/registration/EventDetailsSection";
import {
  ON_HOLD,
  ONLINE_PENDING,
  PENDING_APPROVAL,
  REJECTED,
  SAVE_DRAFT,
  WAIT_LIST,
} from "../../constants";
import AwaitingApprovalScreen from "../../components/registration/AwaitingApprovalScreen";
import {
  fetchRegistrationStatus,
  formatDateRangeToReadable,
  formatDateToWeekDate,
  getApprovalStatus,
  getCurrentSection,
  getFormStatus,
  getInputValues,
  GroupedQuestion,
  handleAWSFileUpload,
  mergeArrayOfObjects,
  useRegistrationData,
  userRegistration,
  validateCurrentSection,
  getAllocatedProgramData,
  getSuccessStatus,
  triggerWebhook,
  getAllocatedProgamPrice,
  stringToNumber,
  validateField,
} from "../../utils/registrationUtils";
import RegistrationSuccess from "../../components/registration/RegistrationSuccess";
// import { CloudUpload } from "@mui/icons-material";
// Types
// import { S3Client, ListObjectsCommand } from "@aws-sdk/client-s3";
// import ProgramPreference from '../../components/ProgramPreference';
import RenderField from "../../common/components/RenderFields";
import FormSubHeader from "../../components/registration/FormSubHeader";
import CustomCard from "../../common/components/CustomCard";
import CustomModal from "../../common/components/CustomModal";
import Breadcrumb from "../../common/components/Breadcrumb";
import { formateDate } from "../../utils/commonFunctions";
import { Avatar } from "@mui/material";
import PaymentCard from "../../components/registration/PaymentCard";
import Footer from "../../common/components/Footer";
import GrayLine from "../../common/components/GrayLine";
import dropdownIcon from "../../assets/images/expandIcon.svg";
export interface Program {
  id: number;
  programId: number;
  name: string;
  code: string;
  description: string;
  startDate: string;
  endDate: string;
  basePrice: string;
  currency: string;
  status: string;
  availableSeats: number;
  duration: string;
  type: {
    id: number;
    name: string;
  };
  sgst?: string;
  cgst?: string;
  igst?: string;
  gstNumber?: string;
}

export interface Question {
  id: number;
  label: string;
  type: string;
  bindingKey: string;
  config: {
    isDisable?: boolean;
    isDefaultValue?: boolean;
    allowMahatriaChoice?: boolean;
    minYears?: number;
    maxYears?: number;
    isRequired?: boolean;
    minCharacter?: number;
    maxCharacters?: number;
    futureDateValidation?: string;
    pastDateValidation?: string;
    minValue?: number;
    maxValue?: number;
    validationPattern?: string;
    endPoint?: string; // For API calls
    conditionalFields?: number[];
    startDate?: string | null;
    endDate?: string | null;
    allowedDigits?: number;
    prefill?: {
      prefillFrom?: number;
      prefillIf?: {
        questionId: number;
        value: string | number | boolean;
      }[];
    };
    dateValidationType?: "static" | "dynamic";
    futureValidation?: {
      unit: "years" | "months" | "days";
      enabled: boolean;
      maxValue?: number | null;
      minValue?: number | null;
    };
    pastValidation?: {
      unit: "years" | "months" | "days";
      enabled: boolean;
      maxValue?: number | null;
      minValue?: number | null;
    };
    showDialog?: {
      type: string;
      isShow: boolean | string;
      imageName: string | null;
      contentType: string | null;
      dialogueContent: string | null;
    } | null;
    dependsOn?: {
      questionId: number;
      value: string | number | boolean;
    }[];
  };
  formSection: {
    id: number;
    name: string;
    description: string;
  };
  questionOptionMaps: Array<{
    option: {
      id: number;
      name: string;
    };
  }>;
}
export interface Section {
  id: number;
  name: string;
  description: string;
  displayOrder: number;
}

export interface ProgramQuestionMap {
  id: number;
  question: Question;
  registrationLevel: string;
  displayOrder: number;
  programQuestionFormSection: Section;
}

export interface ProgramDetails {
  id: number;
  name: string;
  code: string;
  bannerImageUrl?: string;
  description: string;
  basePrice: string;
  currency: string;
  requiresApproval: boolean | null;
  duration: string;
  startDate: string;
  checkinAt: string;
  checkoutAt: string;
  modeOfOperation: string;
  limitedSeats: boolean;
  startsAt?: string;
  endsAt?: string;
  involvesTravel?: boolean;
  noOfSession?: number;
  isGroupedProgram: boolean;
  meta: {
    price: { [key: string]: number };
  };
  type: {
    maxSessionDurationDays: number;
    requiresApproval: boolean;
    requiresPayment: boolean;
    involvesTravel: boolean;
    name: string;
    waitlistApplicable: boolean;
    venue: string;
    meta: {
      price: any;
    };
    isGroupedProgram?: boolean;
  };
  statusMessage?: { message: string[]; state: string };
  registrationId?: string | null;
  blessesProgram?: Program | null;
  sessions: Program[];
  programQuestionMaps: ProgramQuestionMap[];
  groupedPrograms: Program[];
  gstNumber?: string;
  cgst?: string;
  sgst?: string;
  igst?: string;
}

export interface FormResponse {
  [key: string]: any;
}

const DynamicForm = () => {
  const [onwardFile, setOnwardFile] = useState<File | null>(null);
  const [returnFile, setReturnFile] = useState<File | null>(null);
  const [isMobile, setIsMobile] = useState(false);

  // Check if screen is mobile size
  useEffect(() => {
    const checkScreenSize = () => {
      setIsMobile(window.innerWidth < 1029);
    };

    checkScreenSize();
    window.addEventListener("resize", checkScreenSize);

    return () => window.removeEventListener("resize", checkScreenSize);
  }, []);
  const [submitted, setSubmitted] = useState(false);

  const [currentStep, setCurrentStep] = useState<
    | "form"
    | "success"
    | "waitlisted"
    | "pending_approval"
    | "rejected"
    | "on_hold"
  >("form");
  const [searchParams, setSearchParams] = useSearchParams();
  const isSuccessFlag = searchParams.get("isSuccess") === "true";
  const seekerDetails = getItemInLocalStorage("seekerDetails") || {};
  const programId = searchParams.get("programId");
  const {
    loading,
    error,
    programDetails,
    groupedAnswersData,
    userStatus,
    groupedQuestions,
    refetch,
  } = useRegistrationData(programId || "", seekerDetails.id);

  // const [programDetails, setProgramDetails] = useState<ProgramDetails | null>(
  // null,
  // );
  const [handleLoader, setLoading] = useState(false);
  const [formData, setFormData] = useState<{ [key: number]: GroupedQuestion }>(
    groupedAnswersData || {},
  );
  const [currentSectionIndex, setCurrentSectionIndex] = useState(1);
  const [isModalOpen, setModalOpen] = useState(true);
  const [completedSections, setCompletedSections] = useState<Set<number>>(
    new Set(),
  );
  const [errors, setErrors] = useState<{ [key: string]: string }>({});
  const [editMode, setEditMode] = useState(false);
  const [showSuccess, setshowSuccess] = useState(false);
  const [showAdditionalInfo, setShowAdditionalInfo] = useState(false);
  const [editRegistration, setEditRegistration] = useState(false);

  const [sectionLoader, setSectionLoader] = useState(false);

  const [basePrice, setBasePrice] = useState<number | null>(null);
  const { initiatePayment, isScriptLoaded } = useRazorpay();
  const [localGroupedQuestions, setLocalGroupedQuestions] = useState<any>(null);
  const navigate = useNavigate();
  const [showBillingAmount, setShowBillingAmount] = useState(false);
  const paymentCardRef = useRef<HTMLDivElement | null>(null);
  const [isPaymentCardVisible, setIsPaymentCardVisible] = useState(false);
  const [userAllocatedProgram, setAllocatedProgram] = useState<Program | null>(null)
  const fieldRefs = useRef<{ [key: string]: HTMLDivElement | null }>({});
  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        // PaymentCard is visible if any part of it is in viewport
        setIsPaymentCardVisible(entry.isIntersecting);
      },
      {
        threshold: 0.1, // Trigger when 10% of the element is visible
        rootMargin: "0px 0px -50px 0px", // Optional: adjust detection area
      },
    );

    if (paymentCardRef.current) {
      observer.observe(paymentCardRef.current);
    }

    return () => {
      if (paymentCardRef.current) {
        observer.unobserve(paymentCardRef.current);
      }
    };
  }, [currentSectionIndex]); // Re-run when section changes

  const handleShowBillingPopUp = () => {
    setShowBillingAmount(!showBillingAmount);

    // Scroll to PaymentCard component
    if (paymentCardRef.current) {
      paymentCardRef.current.scrollIntoView({
        behavior: "smooth",
        block: "start",
      });
    }
  };

  const location = useLocation();
  const sectionId = location?.state?.sectionId || null;
  useEffect(() => {
    if(userStatus!= null) {
    getCurrentSection(
      setCurrentSectionIndex,
      userStatus,
      editRegistration,
      showAdditionalInfo,
      showSuccess,
    );
    setAllocatedProgram(getAllocatedProgramData(userStatus) || null);

  }
  }, [userStatus, showSuccess, currentStep, showAdditionalInfo]);
  useEffect(() => {
    if (groupedAnswersData) {
      setFormData(groupedAnswersData);
    }
  }, [groupedAnswersData]);

  useEffect(() => {
    if (groupedQuestions && localGroupedQuestions == null) {
      setLocalGroupedQuestions(JSON.parse(JSON.stringify(groupedQuestions)));
    }
  }, [groupedQuestions]);


  useEffect(() => {
    if (sectionId == 1) {
      handleEditRegistration();
    } else if (sectionId == 3) {
      setshowSuccess(false);
      handleEditData();
    }
  }, []);
  const handleFieldChange = (questionId: number, value: any) => {
    const currentValue = formData?.[currentSectionIndex]?.[questionId];
    if (currentValue === value) {
      return; // No state change needed -- Infinite Loop Fix
    }
    if (formData && userStatus && formData[1]) {
      const result = getAllocatedProgamPrice(userStatus);
      const price = result?.price;
      const program = result?.program;
      const { finalValue, inputValues } = getInputValues(
        program,
        formData[currentSectionIndex] || {},
        true,
      );
      if (price) {
        setBasePrice(finalValue?.value);
      }
    }
    if (questionId === 344 && value !== "Online (Through Razorpay)") {
      // If the question is "Payment Mode", set the base price based on the selected payment mode
      const basePrice = getAllocatedProgamPrice(userStatus);
      if (basePrice) {
        setFormData((prev = {}) => ({
          ...prev,
          [currentSectionIndex]: {
            ...(prev && prev[currentSectionIndex]
              ? prev[currentSectionIndex]
              : {}),
            [questionId]: value,
            [345]: basePrice.toString(), // Set the base price in the form data
          },
        }));
      }
    }

    const isFileTypeQuestion =
      programDetails?.programQuestionMaps.find(
        (pqm) => pqm.question.id === questionId,
      )?.question.type === "file";
    const question = programDetails?.programQuestionMaps.find(
      (pqm) => pqm.question.id === questionId,
    )?.question;

    if (isFileTypeQuestion) {
      if (!value || value.length === 0) {
        setFormData((prev = {}) => ({
          ...prev,
          [currentSectionIndex]: {
            ...(prev && prev[currentSectionIndex]
              ? prev[currentSectionIndex]
              : {}),
            [questionId]: "",
          },
        }));
        return;
      } else {
        const bindingKey = programDetails?.programQuestionMaps.find(
          (pqm) => pqm.question.id === questionId,
        )?.question.bindingKey;
        setSectionLoader(true);
        handleAWSFileUpload(value).then((fileUrl) => {
          if (bindingKey === "pictureUrl" || bindingKey === 'uploadOnwardJourneyTicket' || bindingKey === 'uploadReturnJourneyTicket') {
            setSectionLoader(true);
            return postCall(
              "extract-details",
              {
                url: fileUrl,
                type: bindingKey === "pictureUrl" ? "identity_document" : "flight_ticket",
              },
              false,
            )
              .then((response: any) => {
                setSectionLoader(false);
                if(bindingKey === "pictureUrl") {
                  if (!response?.data?.data?.data?.data) {
                    alert(
                      response?.data?.data?.data?.message ||
                      "Failed to extract details from the document.",
                    );
                    return;
                  }
                } else {
                  if (!response?.data?.data?.data?.segments) {
                    alert(
                      response?.data?.data?.data?.message ||
                      "Failed to extract details from the document.",
                    );
                    return;
                  }
                }
                
                if(bindingKey === "uploadOnwardJourneyTicket" || bindingKey === "uploadReturnJourneyTicket") {
                  prefillFormFromExtractedDetails(
                    response,
                    currentSectionIndex,
                    programDetails?.programQuestionMaps,
                  );
                } else {
                  // Map travelInfoNumber to the correct field if present
                  const travelInfoNumber =
                    response?.data?.data?.data?.data?.travelInfoNumber;
                  if (travelInfoNumber) {
                    // Find the question with bindingKey === 'travelInfoNumber' in the current section
                    const currentSection = Object.values(groupedQuestions)[
                      currentSectionIndex - 1
                    ] as any;
                    if (currentSection && currentSection.questions) {
                      const match = currentSection.questions.find(
                        (pqm: any) =>
                          pqm.question &&
                          pqm.question.bindingKey === "travelInfoNumber",
                      );
                      if (match) {
                        setFormData((prev = {}) => ({
                          ...prev,
                          [currentSectionIndex]: {
                            ...(prev && prev[currentSectionIndex]
                              ? prev[currentSectionIndex]
                              : {}),
                            [match.question.id]: travelInfoNumber,
                          },
                        }));
                      }
                    }
                  }
                }
                // Set the uploaded file URL for the field
                setFormData((prev = {}) => ({
                  ...prev,
                  [currentSectionIndex]: {
                    ...(prev && prev[currentSectionIndex]
                      ? prev[currentSectionIndex]
                      : {}),
                    [questionId]: fileUrl?.toString() || "",
                  },
                }));
              })
              .catch((err: any) => {
                setSectionLoader(false);
                console.error(
                  "Failed to extract details from the document.",
                  err,
                );
                alert("Failed to extract details from the document.");
              });
          } else {
            setFormData((prev = {}) => ({
              ...prev,
              [currentSectionIndex]: {
                ...(prev && prev[currentSectionIndex]
                  ? prev[currentSectionIndex]
                  : {}),
                [questionId]: fileUrl?.toString() || "",
              },
            }));
          }
          setSectionLoader(false);
        });
      }
    } else {
      setFormData((prev = {}) => ({
        ...prev,
        [currentSectionIndex]: {
          ...(prev && prev[currentSectionIndex]
            ? prev[currentSectionIndex]
            : {}),
          [questionId]: value,
        },
      }));
      // setFormData((prev) => ({ ...prev, [questionId]: value }));
    }

    // Clear error for this field
    if (errors[questionId]) {
      setErrors((prev) => {
        const newErrors = { ...prev };
        delete newErrors[questionId];
        return newErrors;
      });
    }
  };

  console.log("formData console", formData)

const handleFieldBlur = async (question: Question, value: string) => {
  const error = await validateField(
    question,
    value,
    formData[currentSectionIndex],
    currentSectionIndex,
    userAllocatedProgram
  );
 
  setErrors((prev) => ({
    ...prev,
    [question.id]: error || undefined,
  }));
};

  const handlesubmitFormData = async (
    currentSectionIndex: number,
    isDraft: boolean = false,
  ) => {
    var formattedData = Object.entries(formData[currentSectionIndex]).map(
      ([key, value]) => ({
        questionId: Number(key),
        answer: value.toString(),
      }),
    );
    formattedData = formattedData.filter(
      (item) =>
        item.answer !== undefined && item.answer !== null && item.answer !== "",
    );
    if (currentSectionIndex == 1 && !userStatus) {
      let payload = {
        programId: programDetails?.id,
        // programSessionId: 23,
        isSelfRegister: true,
        answers: formattedData,
        createdBy: getItemInLocalStorage("seekerDetails")?.id || 0,
        updatedBy: getItemInLocalStorage("seekerDetails")?.id || 0,
      };
      if (isDraft) {
        payload = {
          ...payload,
          registrationStatus: "save_as_draft",
        };
      }
     
      const status = await postCall(
        endPoints.programRegistration,
        payload,
        false,
      )
        .then((response) => {
          if (
            response?.data?.statusCode === 200 ||
            response?.data?.statusCode === 201
          ) {
            setEditMode(false);
            return response.data.data;
          } else {
            return {};
          }
        })
        .catch((error) => {
          return {};
        });
      return status;
    } else if (currentSectionIndex == 3) {
      console.log("is Draft payload", formData, currentSectionIndex, isDraft);
      let payload = {
        programRegistrationId: userStatus?.id ? Number(userStatus.id) : undefined,
        programId: programDetails?.id,
        formSectionId: currentSectionIndex,
        // programSessionId: 23,
        isSelfRegister: true,
        answers: formattedData,
      };
      if (isDraft) {
        payload = {
          ...payload,
          registrationStatus: "save_as_draft",
        };
      }
      console.log("draft payload", payload)
      const status = await putCall(endPoints.programRegistration, payload, false)
        .then((response) => {
          if (
            response?.data?.statusCode === 200 ||
            response?.data?.statusCode === 201
          ) {
            setEditMode(false);
            return response.data.data;
          } else {
            return {};
          }
        })
        .catch((error) => {
          return {};
        });
      return status;
    } else {
      console.log("is draft not");
      let payload = {
        programRegistrationId: Number(userStatus?.id),
        programId: programDetails?.id,
        formSectionId: currentSectionIndex,
        // programSessionId: 23,
        isSelfRegister: true,
        answers: formattedData,
        // createdBy: getItemInLocalStorage("seekerDetails")?.id || 0,
        // updatedBy: getItemInLocalStorage("seekerDetails")?.id || 0
      };
       if (isDraft) {
        payload = {
          ...payload,
          registrationStatus: "save_as_draft",
        };
      }
      const status = await putCall(
        endPoints.programRegistration,
        payload,
        false,
      )
        .then((response) => {
          if (
            response?.data?.statusCode === 200 ||
            response?.data?.statusCode === 201
          ) {
            return response.data.data;
          } else {
            return {};
          }
        })
        .catch((error) => {
          console.error("Error submitting form data:", error);
          return {};
        });
      return status;
    }
  };

  const handleNextSession = async (currentSection: any) => {
    console.log(
      formData,
      "CurrentSECTION123",
      currentSection.section.name,
      programDetails?.type.requiresPayment,
      programDetails,
    );
    if (
      currentSection.section.name == "Payment & Invoice" &&
      // programDetails?.type.requiresPayment &&
      formData
      // &&
      // formData[currentSectionIndex][344] == "Online (Through Razorpay)"
    ) {
      console.log(
        formData,
        "CurrentSECTION123",
        currentSection.section.name,
        programDetails?.type.requiresPayment,
        programDetails,
      );
      //  setShowAdditionalInfo(false)
      //  setshowSuccess(true);
      //  setCurrentStep("success");
      await handlePayment();
    } else {
      const newCompletedSections = new Set(completedSections);
      newCompletedSections.add(currentSectionIndex);
      setCompletedSections(newCompletedSections);
      const sections = Object.values(groupedQuestions);
      if (currentSectionIndex < sections.length - 1) {
        setCurrentSectionIndex(currentSectionIndex + 1);
      } else {
        setCurrentStep("success");
        searchParams.set("isSuccess", "true");
        setSearchParams(searchParams);
      }
      refetch();
    }
  };


useEffect(() => {
  if (submitted && Object.keys(errors).length > 0) {
    const firstErrorKey = Object.keys(errors)[0];
    if (firstErrorKey && fieldRefs.current[firstErrorKey]) {
      fieldRefs.current[firstErrorKey]?.scrollIntoView({ behavior: "smooth", block: "center" });
      fieldRefs.current[firstErrorKey]?.focus?.();
    }
    setSubmitted(false);
  }
}, [errors, submitted]);
  const handleSectionComplete = async (currentSection: any) => {
    console.log(
      "Allocated Program: before validation",
      currentSection,
      showAdditionalInfo,
      currentStep,
    );
    setLoading(true);
    const allocatedProgram = getAllocatedProgramData(userStatus);
    const isValid = await validateCurrentSection(
      currentSectionIndex,
      groupedQuestions,
      setErrors,
      formData,
      allocatedProgram,
    );
    if (!isValid) {
      setLoading(false);
      setSubmitted(true);
      return;
    }
    console.log("Allocated Program: handleSectionComplete", isValid, error);
    setLoading(true);
    setEditRegistration(false);
    setShowAdditionalInfo(false);
    if (currentSectionIndex == 2) {
      await handleNextSession(currentSection);
    } else {
      handlesubmitFormData(currentSectionIndex)
        .then(async (status) => {
          if (Object.keys(status).length === 0) {
            setLoading(false);
            alert("Failed to submit form data. Please try again.");
            return;
          } else {
            if (
              programDetails?.type.requiresApproval &&
              status?.registrationStatus === PENDING_APPROVAL
            ) {
              refetch();
              setCurrentStep(PENDING_APPROVAL);
            } else if (status?.registrationStatus == REJECTED) {
              refetch();
              setCurrentStep(REJECTED);
            } else if (status?.registrationStatus == ON_HOLD) {
              refetch();
              setCurrentStep(ON_HOLD);
            } else {
              console.log(
                "Allocated Program: next session",
                showAdditionalInfo,
                currentStep,
              );
              await handleNextSession(currentSection);
            }
            if (currentSectionIndex === 3) {
              setshowSuccess(true);
              setCurrentStep("success");
              searchParams.set("isSuccess", "true");
              setSearchParams(searchParams);
              refetch();
            }
            return;
          }
        })
        .catch((error) => {
          console.error("Error submitting form data:", error);
          return;
        })
        .finally(() => {
          setLoading(false);
        });
    }
    // setLoading(false);
  };

  const handlePayment = async () => {
    const sectionQuestions =
      (Object.values(groupedQuestions)[currentSectionIndex - 1] as any)
        ?.questions || [];

    let formattedData = sectionQuestions
      .filter(
        (pqm: any) =>
          formData[currentSectionIndex] &&
          formData[currentSectionIndex][pqm.question.id] !== undefined &&
          formData[currentSectionIndex][pqm.question.id] != "",
      )
      .reduce((acc: any, pqm: any) => {
        const formKey = pqm.question.bindingKey;
        if(formKey == "tdsAmount"){
          acc[formKey] = stringToNumber(formData[currentSectionIndex][pqm.question.id]);
        } else {
        acc[formKey] = formData[currentSectionIndex][pqm.question.id];
        }
        return acc;
      }, {});
    if (!(formattedData["paymentMode"] == "Online (Through Razorpay)")) {
      formattedData = {
        ...formattedData,
        offlinePaymentMeta: {
          ...formattedData,
          paymentMethod: formattedData["paymentMode"],
        },
      };
      formattedData["paymentMode"] = "offline";
      formattedData.paymentMeta = {
        ...formattedData.paymentMeta,
        // paymentMode: formattedData["paymentMode"],
      };
    } else {
      formattedData = {
        ...formattedData,
      };
      formattedData["paymentMode"] = "online";
    }

    const registeredMeta = Object.entries(formData[currentSectionIndex]).map(
      ([key, value]) => ({
        questionId: Number(key),
        answer: value.toString(),
      }),
    );
    formattedData["paymentMeta"] = registeredMeta.filter(
      (item) =>
        item.answer !== undefined && item.answer !== null && item.answer !== "",
    );

    postCall(`payment/initiate/${userStatus?.id}`, formattedData, false)
      .then((response) => {
        if (
          response?.data?.statusCode >= 200 &&
          response?.data?.statusCode < 300
        ) {
          if (response.data?.data?.paymentStatus == ONLINE_PENDING) {
            initiatePayment({
              amount: response.data?.data?.amount || 10,
              orderId: response?.data?.data?.razorpayOrderId || "",
              keyId: process.env.REACT_APP_RAZORPAY_KEY_ID || "",
              name: "Premium Service",
              description: "Monthly subscription",
              // prefill: {
              //   name: "Harsha",
              //   email: "harsha@divami.com",
              //   contact: "7659950042",
              // },
              theme: { color: "#10b981" },
              onSuccess: (response) => {
                // alert("Payment successful!");
                triggerWebhook(response);
                // setShowAdditionalInfo(true)
                setshowSuccess(true);
                setCurrentStep("success");
                searchParams.set("isSuccess", "true");
                setSearchParams(searchParams);
                refetch();
              },
              onFailure: (error) => {
                console.log("Payment failed:", error);
                alert("Payment failed: " + error?.description);
              },
              onDismiss: () => {
                console.log("Payment dismissed");
                alert("Payment dismissed");
              },
            });
          } else {
            console.log("Payment already completed:", response.data?.data);
            refetch();
            setCurrentStep("success");
            searchParams.set("isSuccess", "true");
            setSearchParams(searchParams);
            // setShowAdditionalInfo(true)
            setshowSuccess(true);
            setLoading(false);
            return;
          }
        } else {
          console.error(
            "Payment initialization failed:",
            response?.data?.message,
          );
          alert("Payment initialization failed: " + response?.data?.message);
        }
        // setCurrentStep("success");
        setLoading(false);
      })
      .catch((error) => {
        console.error("Error initializing payment:", error);
        setLoading(false);
        alert("Error initializing payment: " + error.message);
      });
  };

  const handleEdit = () => {
    setEditMode((prev) => !prev);
  };

  const handlePreviousSection = () => {
    navigate(-1);
  };

  const handleDraft = () => {
    setLoading(true);
    handlesubmitFormData(currentSectionIndex, true)
      .then(async (status) => {
        if (Object.keys(status).length != 0) {
          alert("Draft saved successfully!");
          navigate(-1);
          return;
        }
      })
      .catch((error) => {
        console.error("Error submitting form data:", error);
        return;
      })
      .finally(() => {
        setLoading(false);
      });
  };
  console.log("userStatus abcd", userStatus);
  const displayData = (pqm: ProgramQuestionMap) => {
    const { question } = pqm;
    const value =
      formData && formData[currentSectionIndex]
        ? formData[currentSectionIndex][question.id] || ""
        : "";
    return (
      <div key={question.id} className={styles.fieldGroup}>
        <label className={styles.prefilledfieldLabel}>{question.label}</label>
        {question.type != "file" ? (
          <p className={styles.prefilledfieldValue}>
            {question.type == "draganddrop" ? "" : ""}
            {(question.type == "date" || question.type == "dateandtime") &&
              formateDate(value)}
            {value == false && "No"}
            {value == true && "Yes"}
            {value != true &&
              question.type != "dateandtime" &&
              question.type != "date" &&
              question.type != "draganddrop" &&
              value != false
              ? value
              : ""}
          </p>
        ) : (
          <div className={styles.fileContainer}>
            <Avatar
              src={value}
              sx={{
                width: 60,
                height: 60,
                // boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.3)",
                borderRadius: "20%",
                // marginLeft: "4px",
                "@media (max-width: 780px)": {
                  width: 42,
                  height: 42,
                },
              }}
              data-testid={value}
            />
            {/* <img src= {value} alt={question.label} className={styles.fileImage} /> */}
          </div>
        )}
      </div>
    );
  };

  const handleEditRegistration = () => {
    setCurrentStep("form");
    setEditRegistration(true);
    setEditMode(true);
    setCurrentSectionIndex(1);
    setCompletedSections(new Set());
  };
  const handleEditData = () => {
    console.log("handleEditData called");
    setShowAdditionalInfo(true);
    setshowSuccess(false);
    setCurrentStep("form");
    setCurrentSectionIndex(3);
  };
  const handleModalClose = () => {
    setModalOpen(false);
  };

  // Helper to pre-fill form fields from extract-details API response
  const prefillFormFromExtractedDetails = (
    apiData: any,
    sectionIndex: number,
    questions: any[],
  ) => {
    if (
      !apiData ||
      !apiData.data ||
      !apiData.data.data ||
      !apiData.data.data.data
    )
      return;
    const { tripType, segments } = apiData.data.data.data;
    if (!segments || !Array.isArray(segments) || segments.length === 0) return;
    // Build a map of bindingKey to questionId
    const bindingKeyToQuestionId: Record<string, number> = {};
    questions.forEach((pqm: any) => {
      if (pqm.question && pqm.question.bindingKey) {
        bindingKeyToQuestionId[pqm.question.bindingKey] = pqm.question.id;
      }
    });
    let newFormData = { ...formData };
    if (tripType === "one-way") {
      // Use only the first segment
      const segment = segments[0];
      Object.keys(segment).forEach((key) => {
        if (bindingKeyToQuestionId[key]) {
          if (!newFormData[sectionIndex]) newFormData[sectionIndex] = {};
          newFormData[sectionIndex][bindingKeyToQuestionId[key]] = segment[key];
        }
      });
    } else if (tripType === "round-trip") {
      // Use only the first onward and first return segment
      const onwardSeg = segments.find((seg) => seg.type === "onward");
      const returnSeg = segments.find((seg) => seg.type === "return");
      if (onwardSeg) {
        Object.keys(onwardSeg).forEach((key) => {
          if (bindingKeyToQuestionId[key]) {
            if (!newFormData[sectionIndex]) newFormData[sectionIndex] = {};
            newFormData[sectionIndex][bindingKeyToQuestionId[key]] =
              key.includes("Date") ? new Date(onwardSeg[key]) : onwardSeg[key];
          }
        });
      }
      if (returnSeg) {
        Object.keys(returnSeg).forEach((key) => {
          if (bindingKeyToQuestionId[key]) {
            if (!newFormData[sectionIndex]) newFormData[sectionIndex] = {};
            newFormData[sectionIndex][bindingKeyToQuestionId[key]] =
              key.includes("Date") ? new Date(returnSeg[key]) : returnSeg[key];
          }
        });
      }
    }
    setFormData(newFormData);
  };
  console.log(errors, "errors");

  const renderForm = () => {
    if (!groupedQuestions || !programDetails) return null;
    // const sections = groupedQuestions && Object.values(groupedQuestions);
    // const currentSection = sections && sections[currentSectionIndex - 1];



    const sections = localGroupedQuestions && Object.values(localGroupedQuestions);
    const currentSection = sections && sections[currentSectionIndex - 1];
    // const programDetails = getAllocatedProgramData(userStatus) || null
    //   const { finalValue, inputValues } = getInputValues(userStatus, formData[currentSectionIndex] || {});

    const allocatedProgram = getAllocatedProgramData(userStatus) || null;
    const { finalValue, inputValues } = getInputValues(
      allocatedProgram,
      formData[currentSectionIndex] || {},
    );
    console.log("currentSectionIndex", sectionId);
    return (
      <div className={styles.formWrapperContainer}>
        <div className={styles.formContainer}>
          <div className={styles.formWrapper}>
            {currentSection && (
              <div
                className={
                  currentSectionIndex !== 2
                    ? styles.formSectionContainer
                    : styles.formContainerLeftAlign
                }
              >
                <div className={styles.formSection}>
                  <div className={styles.sectionHeader}>
                    <RegistrationHeader ProgramDetails={programDetails} />
                    <FormSubHeader
                      basePrice={allocatedProgram?.basePrice || 0}
                      eventCost={
                        mergeArrayOfObjects(programDetails?.meta?.price) || null
                      }
                      comapactedEventDetails={{
                        eventName: `${programDetails.name || "-"}`,
                        eventDates: `${programDetails.modeOfOperation == "online" ? (programDetails.startsAt && programDetails.endsAt ? formatDateRangeToReadable(programDetails.startsAt, programDetails.endsAt) : "-") : programDetails.startsAt && programDetails.endsAt ? formatDateRangeToReadable(programDetails.startsAt, programDetails.endsAt) : "-"}`,
                        venue: userStatus?.allocatedProgram
                          ? `${userStatus?.allocatedProgram.venue || "-"}`
                          : "",
                        duration: `${programDetails.duration ? `${programDetails.duration} intensive` : "-"}`,
                      }}
                      currentSectionIndex={currentSectionIndex}
                    />
                    {/* <h2 className={styles.sectionTitle}>Hi {groupedAnswersData?.name || "" }! Let's ensure your profile reflects you fully.</h2> */}
                    {!editMode && currentSection.hasData.length > 0 ? (
                      <>
                        {!editMode && (
                          <>
                            <div className={styles.sectionHeaderText}>
                              <span className={styles.sectionTitle}>
                               Review the details and update if required
                                <span
                                  className={styles.edit}
                                  onClick={handleEdit}
                                >
                                  update details
                                </span>
                              </span>
                            </div>
                            <div
                              className={
                                true
                                  ? styles.fieldsContainer
                                  : styles.fieldsContainerColumn
                              }
                            >
                              {currentSection.hasData.map(
                                (pqm) =>
                                  formData &&
                                  formData[currentSectionIndex] &&
                                  displayData(pqm),
                              )}
                            </div>
                          </>
                        )}
                        {/* </div> */}
                      </>
                    ) : (
                      <>
                        <div className={styles.sectionHeaderEdit}>
                          <div className={styles.sectionHeaderTitleEdit}>
                            {editMode ? (
                              <p className={styles.sectionTitle}>
                                Update {groupedAnswersData?.name || ""} details
                              </p>
                            ) : (
                              currentSectionIndex !== 2 && (
                                <p className={styles.sectionTitle}>
                                  Hi {groupedAnswersData?.name || ""}! Let's
                                  ensure your profile reflects you fully.
                                </p>
                              )
                            )}
                          </div>
                          <div
                            className={
                              false
                                ? styles.editfieldsgridContainer
                                : styles.editfieldsColumnColumn
                            }
                          >
                            {programDetails &&
                              currentSection.questions.map((pqm) => (
                                <>
                                  <RenderField
                                  data-question-id={pqm.question.id}
                                  ref={(el) => { 
                                    fieldRefs.current[pqm.question.id] = el; 
                                  }}
                                    addedclassName={"renderformdragdrop"}
                                    pqm={pqm}
                                    formData={
                                      formData && formData[currentSectionIndex]
                                        ? formData[currentSectionIndex]
                                        : {}
                                    }
                                    errors={errors}
                                    handleFieldChange={handleFieldChange}
                                    programDetails={programDetails}
                                    setFormData={setFormData}
                                    totalData={formData}
                                    basePrice={basePrice}
                                    userStatus = {userStatus}
                                    handleFieldBlur = {handleFieldBlur}
                                  />
                                  {formData &&
                                    pqm?.question?.config?.showDialog?.type ===
                                    "popup" &&
                                    formData[currentSectionIndex] &&
                                    formData[currentSectionIndex][
                                    pqm.question.id
                                    ] ==
                                    pqm?.question?.config?.showDialog
                                      ?.isShow && (
                                      <CustomModal
                                        open={
                                          formData[currentSectionIndex][
                                          pqm.question.id
                                          ] ==
                                          pqm?.question?.config?.showDialog
                                            ?.isShow && isModalOpen
                                        }
                                        onclose={handleModalClose}
                                        description={
                                          pqm?.question?.config?.showDialog
                                            ?.dialogueContent
                                        }
                                        onConfirm={handleModalClose}
                                        confirmText={"ok"}
                                      />
                                    )}

                                  {pqm?.question?.config?.showDialog?.type ===
                                    "card" &&
                                    formData[currentSectionIndex] &&
                                    formData[currentSectionIndex][
                                    pqm.question.id
                                    ] ==
                                    pqm?.question?.config?.showDialog
                                      ?.isShow && (
                                      <CustomCard
                                        content={
                                          pqm?.question?.config?.showDialog
                                            ?.dialogueContent
                                        }
                                      />
                                    )}
                                </>
                              ))}
                          </div>

                        </div>
                      </>
                    )}
                  </div>
                  {!editMode &&
                    currentSection.hasData.length > 0 &&
                    currentSection.needData.length > 0 && (
                      <div className={styles.EditsectionHeader}>
                        <div
                          className={
                            false
                              ? styles.editfieldsgridContainer
                              : styles.editfieldsColumnColumn
                          }
                        >
                          {programDetails &&
                            currentSection.needData.map((pqm) => (
                              <>
                                <RenderField
                                  ref={(el) => { fieldRefs.current[pqm.question.id] = el; }}
                                  addedclassName={"renderformdragdrop"}
                                  pqm={pqm}
                                  formData={
                                    formData
                                      ? formData[currentSectionIndex]
                                      : {}
                                  }
                                  errors={errors}
                                  handleFieldChange={handleFieldChange}
                                  programDetails={programDetails}
                                  setFormData={setFormData}
                                  totalData={formData}
                                  basePrice={basePrice || 0}
                                  userStatus = {userStatus}
                                  handleFieldBlur = {handleFieldBlur}
                                />
                                {formData &&
                                  pqm?.question?.config?.showDialog?.type ===
                                  "popup" &&
                                  formData[currentSectionIndex] &&
                                  formData[currentSectionIndex][
                                  pqm.question.id
                                  ] ==
                                  pqm?.question?.config?.showDialog
                                    ?.isShow && (
                                    <CustomModal
                                      open={
                                        formData[currentSectionIndex][
                                        pqm.question.id
                                        ] ==
                                        pqm?.question?.config?.showDialog
                                          ?.isShow && isModalOpen
                                      }
                                      onclose={handleModalClose}
                                      description={
                                        pqm?.question?.config?.showDialog
                                          ?.dialogueContent
                                      }
                                      onConfirm={handleModalClose}
                                      confirmText={"ok"}
                                    />
                                  )}
                                {formData &&
                                  pqm?.question?.config?.showDialog?.type ===
                                  "card" &&
                                  formData[currentSectionIndex] &&
                                  formData[currentSectionIndex][
                                  pqm.question.id
                                  ] ==
                                  pqm?.question?.config?.showDialog
                                    ?.isShow && (
                                    <CustomCard
                                      content={
                                        pqm?.question?.config?.showDialog
                                          ?.dialogueContent
                                      }
                                    />
                                  )}
                              </>
                            ))}
                        </div>
                      </div>
                    )}

                  {currentSection.subSection.length > 0 && (
                    <div className={styles.EditsectionHeader}>
                      <div
                        className={
                          false
                            ? styles.editfieldsgridContainer
                            : styles.editfieldsColumnColumn
                        }
                      >
                        <p className={styles.mahatriaTitle}>
                          {/* <span className={styles.highlight}>Mahatria</span>'s{" "} */}
                          Please answer the questions below:
                        </p>
                        {programDetails &&
                          currentSection.subSection.map((pqm) => (
                            <>
                              <RenderField
                                  ref={(el) => { fieldRefs.current[pqm.question.id] = el; }}
                                addedclassName={"renderformdragdrop"}
                                pqm={pqm}
                                formData={
                                  formData ? formData[currentSectionIndex] : {}
                                }
                                errors={errors}
                                handleFieldChange={handleFieldChange}
                                programDetails={programDetails}
                                setFormData={setFormData}
                                totalData={formData}
                                basePrice={basePrice || 0}
                                userStatus = {userStatus}
                                handleFieldBlur = {handleFieldBlur}
                              />
                              {formData &&
                                pqm?.question?.config?.showDialog?.type ===
                                "popup" &&
                                formData[currentSectionIndex] &&
                                formData[currentSectionIndex][
                                pqm.question.id
                                ] ==
                                pqm?.question?.config?.showDialog?.isShow && (
                                  <CustomModal
                                    open={
                                      formData[currentSectionIndex][
                                      pqm.question.id
                                      ] ==
                                      pqm?.question?.config?.showDialog
                                        ?.isShow && isModalOpen
                                    }
                                    onclose={handleModalClose}
                                    description={
                                      pqm?.question?.config?.showDialog
                                        ?.dialogueContent
                                    }
                                    onConfirm={handleModalClose}
                                    confirmText={"ok"}
                                  />
                                )}
                              {formData &&
                                pqm?.question?.config?.showDialog?.type ===
                                "card" &&
                                formData[currentSectionIndex] &&
                                formData[currentSectionIndex][
                                pqm.question.id
                                ] ==
                                pqm?.question?.config?.showDialog?.isShow && (
                                  <CustomCard
                                    content={
                                      pqm?.question?.config?.showDialog
                                        ?.dialogueContent
                                    }
                                  />
                                )}
                            </>
                          ))}
                      </div>
                    </div>
                  )}
                  {isMobile && currentSectionIndex == 2 && (
                    <div ref={paymentCardRef}>
                      <PaymentCard
                        inputsObject={inputValues}
                        finalValue={finalValue}
                      />
                    </div>
                  )}
                  {currentSectionIndex == 2 && !isPaymentCardVisible && (
                    <div className={styles.amountStickyFooter}>
                      <div
                        className={styles.lastLine}
                        onClick={handleShowBillingPopUp}
                      >
                        <div className={styles.billingAmountShowPopUp}>
                          <div className={styles.amountToBe}>
                            Amount to be paid
                          </div>
                          <div className={styles.totalAmountMobile}>
                            <div>{finalValue?.value || "Total Amount"}</div>
                            <img
                              src={dropdownIcon}
                              alt="dropdown icon"
                              loading="lazy"
                            />
                          </div>
                        </div>
                        <GrayLine />
                      </div>
                    </div>
                  )}
                  <div className={styles.formActions}>
                    <button
                      onClick={() => handlePreviousSection()}
                      disabled={loading}
                      className={styles.secondaryButton}
                    >
                      cancel
                    </button>
                    {
                      (((currentSectionIndex == 1) && (userStatus?.registrationStatus == SAVE_DRAFT)) || (!(userStatus?.registrationStatus) && currentSectionIndex == 1)) &&
                        // (((currentSectionIndex == 3) && (userStatus?.travelInfo?.length === 0)) || ((userStatus?.travelInfo[0]?.travelInfoStatus == SAVE_DRAFT) && currentSectionIndex == 3))) &&
                      <button
                        onClick={() => handleDraft()}
                        disabled={loading}
                        className={styles.secondaryButton}
                      >
                        save as draft
                      </button>
                    }

                    <Button
                      onClick={() => handleSectionComplete(currentSection)}
                      disable={loading}
                      type="button"
                      buttonClassName={styles.primaryButton}
                      buttonTextClassName={styles.primaryButtonText}
                    >
                      submit
                    </Button>
                  </div>
                </div>
              </div>
            )}
          </div>
          {/* <div className={styles.footerContainer}>
            <Footer />
          </div> */}
        </div>
        {sectionLoader && <Loader type="large" />}
        {currentSectionIndex == 2 && !isMobile && (
          <PaymentCard inputsObject={inputValues} finalValue={finalValue} />
        )}
      </div>
    );
  };

  const breadcrumbItems = [{ label: programDetails?.name, path: "/list" }];
  const isSuccess =
    currentStep === "success" ||
    getSuccessStatus(showSuccess, userStatus, showAdditionalInfo);
  const isAwaitingApproval = getApprovalStatus(userStatus, editRegistration);

  return (
    <div
      className={[
        styles.container,
        isSuccess ? styles.success : "",
        isAwaitingApproval ? styles.awaitingApproval : "",
      ].join(" ")}
    >
      <Breadcrumb items={breadcrumbItems} />
      {!loading && !handleLoader ? (
        <div className={styles.mainContainer}>
          {!showSuccess &&
            getFormStatus(
              userStatus,
              programDetails,
              showAdditionalInfo,
              editRegistration,
            ) &&
            !getSuccessStatus(showSuccess, userStatus, showAdditionalInfo) &&
            !isSuccessFlag &&
            renderForm()}
          {(currentStep == "success" ||
            isSuccessFlag ||
            getSuccessStatus(showSuccess, userStatus, showAdditionalInfo)) && (
            <RegistrationSuccess
              event={programDetails}
              personalInfo={userStatus}
              onBack={() => navigate("/infinipath/list", { replace: true })}
              handleEditData={handleEditData}
              fillAdditionalInfo={programDetails?.type.involvesTravel}
            />
          )}
          {getApprovalStatus(userStatus, editRegistration) && (
            <AwaitingApprovalScreen
              userStatus={userStatus}
              onEditInfo={handleEditRegistration}
              onBack={() => navigate("/infinipath/list", { replace: true })}
              event={programDetails}
              editRegistration={editRegistration}
            />
          )}
        </div>
      ) : (
        <Loader type="large" />
      )}
      {(getApprovalStatus(userStatus, editRegistration) ||
        currentStep == "success" ||
        isSuccessFlag ||
        getSuccessStatus(showSuccess, userStatus, showAdditionalInfo)) && (
          <div className={styles.successFooterContainer}>
            <Footer />
          </div>
        )}
    </div>
  );
};

export default DynamicForm;

// Update UploadSlot to use className instead of style
export const UploadSlot = ({
  label,
  uploadedFile,
  onFileChange,
}: {
  label: string;
  uploadedFile: File | null;
  onFileChange: (file: File) => void;
}) => {
  const [dragActive, setDragActive] = useState(false);

  const handleFileChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const file = e.target.files && e.target.files[0];
    if (file) {
      onFileChange(file);
    }
  };

  const handleDragOver = (e: React.DragEvent<HTMLDivElement>) => {
    e.preventDefault();
    e.stopPropagation();
    setDragActive(true);
  };
  const handleDragLeave = (e: React.DragEvent<HTMLDivElement>) => {
    e.preventDefault();
    e.stopPropagation();
    setDragActive(false);
  };
  const handleDrop = (e: React.DragEvent<HTMLDivElement>) => {
    e.preventDefault();
    e.stopPropagation();
    setDragActive(false);
    if (e.dataTransfer.files && e.dataTransfer.files[0]) {
      onFileChange(e.dataTransfer.files[0]);
    }
  };

  // Render thumbnail for images, icon for PDF
  const renderPreview = () => {
    if (!uploadedFile) return null;
    if (uploadedFile.includes('png') || uploadedFile.includes('jpeg') || uploadedFile.includes('jpg') || uploadedFile.includes('webp')) {
      return (
        <img
          src={uploadedFile}
          alt="uploaded"
          className={styles.thumbnail}
        />
      );
    } else if (uploadedFile.includes("pdf")) {
      return (
        <span
          className={styles.thumbnail}
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            fontSize: "2rem",
            background: "#f3f4f6",
          }}
        >
          📄
        </span>
      );
    } else {
      return null;
    }
  };

  return (
    <div className={styles.uploadBox}>
      <label className={styles.uploadLabel}>{label}</label>
      {uploadedFile ? (
        <div className={styles.uploadedPreview}>
          {renderPreview()}
          <div>
            <div className={styles.fileName}>{uploadedFile.name}</div>
            <div>
              <span
                className={styles.reuploadLabel}
                onClick={() => document.getElementById(label)?.click()}
              >
                re-upload file
              </span>
              <input
                type="file"
                accept="image/*,.pdf"
                id={label}
                style={{ display: "none" }}
                onChange={handleFileChange}
              />
            </div>
          </div>
        </div>
      ) : (
        <div
          className={
            dragActive
              ? `${styles.dropArea} ${styles.dragActive}`
              : styles.dropArea
          }
          onDragOver={handleDragOver}
          onDragLeave={handleDragLeave}
          onDrop={handleDrop}
        >
          <p className={styles.dragDropLabel}>
            Drag and drop or{" "}
            <label htmlFor={label} className={styles.uploadLink}>
              upload file here
            </label>
            <input
              type="file"
              accept="image/*,.pdf"
              id={label}
              style={{ display: "none" }}
              onChange={handleFileChange}
            />
          </p>
          <p className={styles.fileTypes}>
            Please upload your picture in (JPEG/PNG/PDF)
          </p>
        </div>
      )}
    </div>
  );
};
